import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getDoctors, getServices } from "@/lib/api";
import SectionTitle from "@/components/SectionTitle";

export default function Doctors() {
  const [doctors, setDoctors] = useState([]);
  const [services, setServices] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    getDoctors().then(setDoctors).catch(() => {});
    getServices().then(setServices).catch(() => {});
  }, []);

  const visible = filter === "all" ? doctors : doctors.filter((d) => d.department_slug === filter);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="doctors-page">
      <SectionTitle
        eyebrow="Our specialists"
        title="Doctors who lead with empathy."
        description="Board-certified, deeply experienced, and quietly committed to making healthcare feel less like an ordeal."
      />

      <div className="flex flex-wrap gap-2 mb-10">
        <button
          data-testid="filter-all"
          onClick={() => setFilter("all")}
          className={`px-5 py-2.5 rounded-full text-sm border transition-all ${
            filter === "all" ? "bg-brand-ink text-brand-bone border-brand-ink" : "bg-white text-brand-ink border-brand-border hover:border-brand-ink"
          }`}
        >
          All
        </button>
        {services.map((s) => (
          <button
            key={s.slug}
            data-testid={`filter-${s.slug}`}
            onClick={() => setFilter(s.slug)}
            className={`px-5 py-2.5 rounded-full text-sm border transition-all ${
              filter === s.slug ? "bg-brand-ink text-brand-bone border-brand-ink" : "bg-white text-brand-ink border-brand-border hover:border-brand-ink"
            }`}
          >
            {s.name}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {visible.map((d) => (
          <Link
            key={d.id}
            to={`/doctors/${d.id}`}
            data-testid={`doctor-tile-${d.id}`}
            className="group bg-white rounded-3xl overflow-hidden border border-brand-border hover:-translate-y-1 transition-transform"
          >
            <div className="aspect-[4/5] overflow-hidden bg-[#E8ECE4]">
              <img src={d.image} alt={d.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="p-5">
              <div className="text-xs uppercase tracking-wider text-brand-sage mb-1">{d.specialty}</div>
              <div className="font-serif text-xl text-brand-ink">{d.name}</div>
              <div className="text-sm text-brand-muted mt-1.5">{d.experience_years} years · {d.languages.slice(0,2).join(", ")}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
